const ORACLE_HEADER_HEIGHT = 68;
const layoutStyles = {
  oracleHeader: {
    height: ORACLE_HEADER_HEIGHT,
  },
  header: {
    height: 40,
  },
  subheader: {
    height: 30,
  },
  rightDrawerModal: {
    leftSpace: 140,
    topSpace: ORACLE_HEADER_HEIGHT,
    toolbarHeight: 60,
  },
  routeList: {
    width: 314,
  },
};

export default layoutStyles;
